import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowUpRight } from '@phosphor-icons/react';
import { LogoPill } from '@/components/LogoPill';
import { buildSeoHead } from '@/lib/seo';
import s from './waitlist.module.scss';

function buildOgMeta() {
  return buildSeoHead({
    title: 'Fragments Cloud Coming Soon',
    description:
      'Fragments Cloud is in private production testing. Join the public waitlist from the Fragments website.',
    path: '/waitlist',
    canonicalPath: '/',
    keywords: ['fragments cloud', 'design system governance'],
    index: false,
  });
}

export const Route = createFileRoute('/waitlist')({
  component: WaitlistPage,
  head: () => buildOgMeta(),
});

function WaitlistPage() {
  return (
    <main className={s.page}>
      <div className={s.ambientGlow} aria-hidden />
      <section className={s.comingSoon}>
        <LogoPill size={56} />
        <p className={s.comingSoonEyebrow}>Private production testing</p>
        <h1 className={s.comingSoonTitle}>Fragments Cloud is coming soon</h1>
        <p className={s.comingSoonText}>
          We are opening access in small batches. Join the waitlist on the
          Fragments website, or use your team invite if you already have one.
        </p>
        <div className={s.comingSoonActions}>
          <a
            className={s.comingSoonPrimary}
            href="https://usefragments.com/#waitlist"
          >
            Join the waitlist
            <ArrowUpRight size={15} weight="bold" />
          </a>
          <Link className={s.comingSoonSecondary} to="/sign-in">
            Sign in
          </Link>
        </div>
      </section>
    </main>
  );
}
